import { Button, Input, Row, Col, notification } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    CheckCircleFilled,
    CloseCircleFilled
} from "@ant-design/icons";
import './PCIProxy.scss';


declare global {
    interface Window {
        SecureFields: any;
    }
}
interface PCIProxyProps {
    merchantId: string;
    onSuccess: (transactionId: string, dateExpiration: string) => void;

}

const CardTokenizeForm = (props: PCIProxyProps) => {
    const secureFieldsRef = useRef<any>(null);
    const { t } = useTranslation();
    const [transactionId, setTransactionId] = useState<string | null>(null);


    const [isExpiryValid, setIsExpiryValid] = useState(false);

    const formatExpiry = (value: string) => {
        // Solo números, máximo 4
        const digits = value.replace(/\D/g, "").slice(0, 4);

        const month = digits.slice(0, 2);
        const year = digits.slice(2, 4);

        if (digits.length <= 2) {
            return month;
        }

        return `${month}/${year}`;
    };


    const validateExpiry = (value: string): boolean => {
        const match = value.match(/^(\d{2})\s?\/\s?(\d{2})$/);
        if (!match) return false;

        const month = parseInt(match[1], 10);
        const year = parseInt(match[2], 10);

        if (month < 1 || month > 12) return false;

        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const currentYear = now.getFullYear() % 100;

        if (year < currentYear) return false;
        if (year === currentYear && month < currentMonth) return false;

        return true;
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://pay.sandbox.datatrans.com/upp/payment/js/secure-fields-2.0.0.min.js";
        script.async = true;

        script.onload = () => {
            const secureFields = new window.SecureFields();

            secureFields.initTokenize(
                props.merchantId,
                {
                    cardNumber: {
                        placeholderElementId: "card-number",
                        inputType: "tel",
                    },
                    cvv: {
                        placeholderElementId: "cvv-number",
                        inputType: "tel",
                    },
                },
                {}
            );


            secureFields.on("ready", () => {
                secureFields.setStyle(
                    "cardNumber",
                    "width: 100%; height: 100%; padding-top: 5px; padding-left: 11px; padding-right: 11px; border: none; font-size: 16px;"
                );
                secureFields.setStyle(
                    "cvv",
                    "width: 70px; height: 100%; padding-top: 5px; padding-left: 11px; padding-right: 11px; border: none; font-size: 16px;"
                );

                secureFields.setPlaceholder("cardNumber", t("card.number"));
                secureFields.setPlaceholder("cvv", "CVV");
            });

            secureFields.on("success", (data: any) => {

                setTransactionId(data.transactionId);
                const expiryInput = document.getElementById("expiry") as HTMLInputElement;
                const expiry = expiryInput?.value ?? "";

                props.onSuccess(data.transactionId, expiry || "");
            });

            secureFieldsRef.current = secureFields;
        };

        document.body.appendChild(script);
    }, [t]);

    const submit = () => {
        if (!isExpiryValid) return;

        const expiryInput = document.getElementById("expiry") as HTMLInputElement;
        const [month, year] = expiryInput.value.split("/").map(v => v.trim());

        secureFieldsRef.current.submit({
            expm: month,
            expy: year,
        });
    };
    const [expirationDate, setExpirationDate] = useState<string | null>(null);

    return (
        <div className="pci-proxy">
            <Row gutter={[16, 16]} align="middle">

                {/* Tarjeta */}
                <Col xs={24} md={18} xxl={14} className="card-wrapper" >

                    <Col id="card-number" xs={15} md={13} xxl={14} />
                    <Col xs={4} md={5} xxl={5}>
                        <Input
                            id="expiry"
                            placeholder="MM/YY"
                            bordered={false}
                            maxLength={5}
                            inputMode="numeric"
                            onChange={(e) => {
                                const formatted = formatExpiry(e.target.value);
                                e.target.value = formatted;

                                const isValid = validateExpiry(formatted);
                                setIsExpiryValid(isValid);

                                if (isValid) {
                                    setExpirationDate(formatted); //  GUARDAMOS MM/YY
                                } else {
                                    setExpirationDate(null);
                                }
                            }}
                            className="expiration"

                        />
                    </Col>

                    <Col id="cvv-number" xs={3} md={4} xxl={4} />
                    <Col xs={2} md={2} xxl={1} className="icon-wrapper" >
                        {transactionId ? (
                            <CheckCircleFilled className="correct-data" />
                        ) : (
                            <CloseCircleFilled className="incorrect-data" />
                        )}
                    </Col>

                </Col>

                {/* Botón */}
                <Col xs={24} md={6} xxl={10}>
                    <Button
                        onClick={submit}
                        className="app-button card-payment"
                        disabled={!isExpiryValid}
                    >
                        {t("button.confirm")}
                    </Button>
                </Col>
            </Row>

        </div>
    );
};

export default CardTokenizeForm;
